import BackdropLoading from 'components/common/BackdropLoading';
import { useUserAuth } from 'hooks/useUserAuth';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Redirect, Route, RouteProps } from 'react-router-dom';

export const PublicRoute = ({ children, ...rest }: RouteProps) => {
  const { status } = useUserAuth();
  const { t } = useTranslation();

  const renderByStatus = () => {
    if (status === 'loading') return <BackdropLoading open loadingText={t('common:loading')} />;
    if (status === 'authenticated') return <Redirect to="/" />;
    return children as any;
  };

  return <Route {...rest} render={renderByStatus} />;
};
